<template>
    <!-- Product Schema By Schema.org -->
    <teleport to="head">
        <component :is="'script'" type="application/ld+json" v-text="productSchema">
        </component>
    </teleport>


    <div v-if="(typeof productInfo.id) !== 'undefined'" ref="productCardVerticalRef"
        class=" product-card-vertical h-full flex flex-col max-w-sm mx-auto lg:mx-0 md:mx-0 bg-white rounded-lg border border-gray-200 md:h-[400px] ">
        <!-- product image -->
        <router-link :to="productDetailsRoute" class="product-card-vertical_img relative md:min-h-[190px] min-h-[165px] ">
            <!-- not available label -->
            <span v-if="productInfo?.quantity == 0"
                class="product-card-vertical_not-available absolute top-4 left-4  font-bold text-white text-sm py-2 px-4 bg-red rounded-md">
                {{ $t('messages.Not_Available') }}
            </span>
            <!-- discount label -->
            <span v-if="productInfo.discounted_label && productInfo?.quantity > 0"
                class="product-card-vertical_offer absolute top-4 left-4  font-bold text-dark-4 text-sm py-2 px-4 bg-primary rounded-md">
                {{ $filters.RTLNumbers(productInfo.discounted_label) }} {{ t('general.Off') }}
            </span>

            <img v-if="productInfo.image" class="rounded-t-lg w-full h-[190px] max-h-[190px] object-contain"
                :src="productInfo.image" :alt="productInfo.title" />
            <img v-else src="../../assets/images/placeholder-image.svg" class="rounded-t-lg w-full !object-none"
                :src="productInfo.image" :alt="productInfo.title" />
        </router-link>

        <div class="product-card-vertical_info p-4 relative h-full flex flex-col min-h-[184px] w-full ">
            <button v-if="isLoggedIn"
                class="absolute -top-[22px] end-4 bg-white product-card-vertical_favorite shadow-md shadow-light-gray-8 rounded-full p-2 "
                @click="addToWishListRequest(product)">
                <img :src="productInfo.is_wishlisted ? require('@/assets/icons/ic-heart-fill.svg') : require('@/assets/icons/ic-heart.svg')"
                    alt="add to favorites " />
            </button>
            <p class="product-card-vertical_title font-medium text-dark-gray-3 mb-2 line-clamp-2 leading-[20px]">{{
                productInfo.title }}</p>
            <p v-if="productInfo.brand" class="text-dark-gray-3  mb-2 line-clamp-1 ">{{ productInfo.brand }}</p>
            <p class="product-card-vertical_price text-sm text-dark-gray-9">
                <span class="font-bold text-lg text-dark-5">
                    {{ productInfo?.discounted_price!= '0' ?   $filters.RTLNumbers(productInfo?.discounted_price)  : $filters.RTLNumbers(productInfo?.price) }}
                </span> {{t('currency.EGP')}}
                <span class="text-sm text-dark-gray-6 line-through" v-if="productInfo?.discounted_price != '0'">{{ $filters.RTLNumbers(productInfo?.price) }} {{t('currency.EGP')}}</span>
                <span v-if="productInfo.unit && productInfo.factor" class="ms-2 text-sm text-dark-2/50 uppercase">
                    {{ $filters.RTLNumbers(
                        isUnitHasBrackets(productInfo.unit) ?
                            productInfo.unit :
                            "(" + productInfo.unit + ")") }}
                </span>
            </p>

            <div v-if="productInfo.in_cart || orderQuantity > 0"
                class="choose-product-quantity grid grid-cols-5 gap-x-2 mt-auto">

                <div class="quantities col-span-12 relative">
                    <input type="text" id="quantity" v-model="orderQuantity" v-numberOnly autocomplete="off"
                        @change="updateQuantity(product)"
                        class=" pe-6 py-3 ps-0 focus:ring-0 text-center w-full h-full overflow-hidden bg-light-gray-13 border-0 rounded-md" />
                    <div
                        class="h-full grid grid-cols-1 divide-y w-6 absolute end-0 top-0 bottom-0 bg-primary px-1 rounded-te-md rounded-be-md">

                        <button :disabled="orderQuantity >= productInfo.quantity"
                            class="h-full flex flex-col justify-center items-center bg-primary active:shadow-lg"
                            @click="increaseOrderQuantity(product)">
                            <font-awesome-icon icon="chevron-up" class="h-3 w-3 text-secondary text-base	 rtl-icon" />
                        </button>

                        <button :disabled="(orderQuantity == 1)" @click="decreaseOrderQuantity(product)"
                            class="w-full h-full flex flex-col justify-center items-center bg-primary active:shadow-lg">
                            <font-awesome-icon icon="chevron-down" class="h-3 w-3 text-secondary text-base	 rtl-icon" />
                        </button>
                    </div>
                </div>

<!--                      <primary-button @click="updateQuantity(product)"
                    :disabled="orderQuantity == 0 || orderQuantity > productInfo?.quantity"
                    :class="{ 'grayscale !text-dark-gray-7 !bg-light-gray-9 hover:bg-light-gray-9 hover:text-dark-gray-7': orderQuantity == 0 || orderQuantity > productInfo?.quantity}"
                    class="col-span-3 font-medium text-base	 text-center flex justify-center items-center add-btn">
                    <a class="group me-2  flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                            stroke="currentColor" aria-hidden="true" class="flex-shrink-0 h-6 w-6 white group-hover:text-white"
                            :class="{ 'group-hover:text-inherit ': orderQuantity == 0 }" data-v-f7c795a4>
                            <path stroke-linecap="round" stroke-linejoin="round" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z">
                            </path>
                        </svg></a>
            
                    <p class="">{{$t('buttons.Update')}}</p>
                </primary-button>  -->
            </div>

            <secondary-button v-if="productInfo?.quantity == 0"
                :class="{ 'grayscale !text-dark-gray-7 !bg-light-gray-9 hover:bg-light-gray-9 hover:text-dark-gray-7': productInfo?.is_notified }"
                @click="notifyMe(product)" :disabled="productInfo?.is_notified" class="w-full mt-auto text-base	py-3 px-4">
                {{ productInfo?.is_notified ? t('buttons.Notified') : t('buttons.Notify_Me') }}
            </secondary-button>
            <primary-button v-if="!productInfo.in_cart && productInfo?.quantity != 0 && orderQuantity == 0"
                @click="addToCart(product)" class="w-full mt-auto text-base	"
                :class="{ 'grayscale !text-dark-gray-7 !bg-light-gray-9 hover:bg-light-gray-9 hover:text-dark-gray-7': productInfo?.quantity == 0 }">
                {{ t('buttons.Add_to_Cart') }}
            </primary-button>


        </div>
    </div>
    <!-- loader -->
    <Loader :modalIsOpen="isLoading" :initFocusedRef="productCardVerticalRef" class="" :widthSM="true"></Loader>
</template>

<script>
import { ref, onBeforeMount, computed, nextTick } from "vue"
import { useStore } from 'vuex'
import { useRouter } from "vue-router"
import { numberOnly } from '@/common/Directives/numberOnly';
import { useI18n } from "vue-i18n";

import Routes from '@/common/Routes'
import Cart from "@/models/Cart"
import Product from "@/models/Product"
import Response from "@/common/Response"
import Request from "@/common/Request"

import PrimaryButton from "@/components/atoms/buttons/PrimaryButton"
import SecondaryButton from "@/components/atoms/buttons/SecondaryButton.vue"
import Loader from "@/components/atoms/Loader";

export default {
    name: "product-card-vertical",
    directives: {
        'numberOnly': numberOnly
    },
    components: {
        PrimaryButton,
        SecondaryButton,
        Loader
    },
    props: ["product"],
    setup(props) {
        const store = useStore()
        const { t } = useI18n();
        const router = useRouter()
        const isLoading = ref(false)
        const productCardVerticalRef = ref()
        const isLoggedIn = computed(() => { return store.getters.isLoggedIn })
        const productInfo = ref({})
        const addClicked = ref(false)

        //add to cart
        const orderQuantity = ref(store.getters.cartProducts?.filter((product) => props.product.id == product.id)[0]?.quantity || 0)
        const increaseOrderQuantity = function (product) {
            orderQuantity.value = parseInt(orderQuantity.value) + 1
            throttle(updateQuantity, 1000);
        }
        const decreaseOrderQuantity = function (product) {
            if (orderQuantity.value > 0) {
                orderQuantity.value = parseInt(orderQuantity.value) - 1
                throttle(updateQuantity, 1000);
            }
        }

        const updateQuantity = function (product) {
            let requestStatus = 2
            addToCartRequest(requestStatus, product)
        }
        const inThrottle = ref(false);
        const throttle = function (func, limit) {
            if (!inThrottle.value) {
                inThrottle.value = true;
                setTimeout(() => {
                    func();
                    inThrottle.value = false;
                }, limit);
            }
        }
        const addToCartRequest = function (requestStatus, product) {
            isLoading.value = true
            //toggle add quantity Btn to add to cart Btn
            addClicked.value = false
            //add to cart action
            let payload = [{
                product_id: productInfo.value.id,
                quantity: orderQuantity.value
            }]
            new Cart().addToCart(payload).then((response) => {
                //update local storage and cart store
                const cartOrder = response.data.data
                store.dispatch("updateCartOrder", cartOrder)
                localStorage.setItem('cart_order', JSON.stringify(cartOrder));
                isLoading.value = false
                //display success toaster
                new Response({ message: `${requestStatus == 1 ? t('messages.Product_Added_Successfully') : t('messages.quantity_updated_successfully')} ` }).displaySuccess()
            }).catch((err) => {
                isLoading.value = false
            });
            // //reset quantity input
            // orderQuantity.value = 1
        }

        // notify client when product out of stock
        const notifyMe = function (product) {
            isLoading.value = true
            new Request().get(`product/notify/${product.id}`).then((res) => {
                isLoading.value = false
                //display success toaster
                if (res) {
                    if (store.getters.userArea) {
                        new Response({ message: t('messages.notify_me_msg') }).displaySuccess()
                    } else {
                        store.commit('selectAreaModal', true)
                    }
                }
            }).catch((err) => {
                isLoading.value = false
            })
        }

        const isUnitHasBrackets = function (unitValue) {
            return unitValue.indexOf('(') == -1 ? false : true
        }

        //add to wishlist 
        const isWishlistProduct = ref(false)
        const addToWishListRequest = function (product) {
            let payload = {
                product_id: product.id,
            }
            new Product().addToWishlist(payload).then((response) => {
                if (response?.data) {
                    isLoading.value = false
                    //display success toaster
                    new Response({ message: `${productInfo.value.is_wishlisted ? t('messages.removed_from_wishlist') : t('messages.added_to_wishlist')} ` }).displaySuccess()

                    //set new wishlist status
                    productInfo.value.is_wishlisted = !productInfo.value.is_wishlisted
                    //refresh page if curren router is wishlist page
                    if (router.currentRoute.value.fullPath.includes(Routes.WISHLIST.name)) {
                        return router.go(Routes.WISHLIST)
                    }

                } else {
                    isLoading.value = false
                }

            }).catch((err) => {
                isLoading.value = false
            }).then(() => {
                isLoading.value = false
            });
        }

        //product schema 
        const productSchema = ref({
            "@context": "https://schema.org",
            "@type": "Product",
            "productID": props.product.id,
            "name": props.product.title,
            "image": props.product.image,
            "brand": props.product.brand,
            "description": props.product.description,
            "image": props.product.image,
            "category": props.product.category.title,
            "offers": {
                "@type": "Offer",
                "availability": "https://schema.org/InStock",
                "price": props.product.price,
                "priceCurrency": "EGP",
                "seller": "RDNA"
            },
        })

        const setDefaultImage = function () {
            let images = Array.from(document.getElementsByTagName('img'))
            images.forEach(image => {
                image.addEventListener("error", function () {
                    image.error = null
                    image.removeAttribute('src');
                    image.setAttribute('src', require('@/assets/images/placeholder-image.svg'));
                    image.classList.add('!object-none')
                });
            });
        }
        onBeforeMount(async () => {
            productInfo.value = props.product

            //broken images 
            await nextTick()
            setDefaultImage()
        })



        return {
            t,
            productCardVerticalRef,
            isLoading,
            isLoggedIn,
            productSchema,
            productInfo,
            isUnitHasBrackets,
            //add to cart
            addClicked,
            orderQuantity,
            increaseOrderQuantity,
            decreaseOrderQuantity,
            addToCartRequest,
            addToCart(product) {
                if (store.getters.userArea) {
                    let requestStatus = 1
                    orderQuantity.value = parseInt(orderQuantity.value) + 1
                    addToCartRequest(requestStatus, product)
                } else {
                    store.commit('selectAreaModal', true)
                }
            },
            updateQuantity,
            //notify client
            notifyMe,
            //add to wishlist
            isWishlistProduct,
            addToWishListRequest,
            //single page routes
            productDetailsRoute: {
                name: Routes.PRODUCT_DETAILS.name,
                params: { productSlug: props?.product?.slug ? props?.product?.slug : props?.product?.id + props?.product?.title?.toLowerCase().replace(' ', '-') }
            },

        }
    },
}
</script>
<style scoped lang="scss">
.add-btn {
    p {
        line-height: 1.5;
    }
}
</style>